import { cx } from "./ui.tsx";

/**
 * La marca, servida desde los archivos originales del kit.
 *
 * Antes esto era un SVG dibujado a mano y el nombre compuesto con Nunito. Se
 * parecía, y parecerse no basta: el chulo real es más grande y va centrado
 * dentro de la intersección —el mío se salía— y el logotipo tiene su propia
 * tipografía, que no es la que yo estaba aproximando.
 *
 * Los originales viven en `marca/`, fuera de `public/`, para que no se
 * desplieguen 1,2 MB que nadie pide. De ahí salen los tamaños que sirve la app.
 */

/** El símbolo solo. Funciona sobre claro y sobre oscuro sin cambiar de archivo. */
export function Marca({ className }: { className?: string }) {
  return (
    <img
      src="/marca-simbolo.png"
      alt=""
      width={96}
      height={96}
      className={cx("size-8", className)}
    />
  );
}

/**
 * El logotipo completo.
 *
 * `variante` existe porque el tema no basta: el panel de la pantalla de entrada
 * es oscuro **en los dos temas**, así que ahí hay que forzar el blanco o la
 * palabra «drando», que va en Tinta, desaparece sobre su propio fondo.
 */
export function MarcaCompleta({
  className,
  variante = "auto",
}: {
  className?: string;
  /** `auto` sigue el tema; `blanco` se impone, para fondos oscuros fijos. */
  variante?: "auto" | "blanco";
}) {
  const alto = "h-7 w-auto";

  if (variante === "blanco") {
    return (
      <img
        src="/marca-horizontal-blanco.png"
        alt="4drando"
        width={375}
        height={96}
        className={cx(alto, className)}
      />
    );
  }

  return (
    <span className={cx("inline-flex items-center", className)}>
      <img
        src="/marca-horizontal.png"
        alt="4drando"
        width={375}
        height={96}
        className={cx(alto, "oscuro:hidden")}
      />
      <img
        src="/marca-horizontal-blanco.png"
        alt=""
        aria-hidden
        width={375}
        height={96}
        className={cx(alto, "hidden oscuro:block")}
      />
    </span>
  );
}
